import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex w-full h-full"
}
const _hoisted_2 = {
  key: 1,
  class: "flex h-full flex-col py-10 px-4 space-y-10"
}
const _hoisted_3 = { class: "mt-0 flex flex-col w-full space-y-5" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col space-y-3"
}
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col space-y-3"
}
const _hoisted_6 = {
  key: 2,
  class: "flex rounded-md bg-brand-dark-gray p-3 px-4 space-x-2.5"
}
const _hoisted_7 = { class: "flex flex-col space-y-10" }
const _hoisted_8 = { class: "flex flex-col space-y-5" }
const _hoisted_9 = { class: "flex flex-col pb-10" }
const _hoisted_10 = { class: "flex m-auto space-x-2.5" }
const _hoisted_11 = {
  key: 0,
  class: "my-auto pt-0.5"
}
const _hoisted_12 = {
  key: 1,
  class: "my-auto"
}
const _hoisted_13 = {
  key: 2,
  class: "flex h-full flex-col py-10 px-4 justify-center space-y-6"
}
const _hoisted_14 = { class: "flex flex-col m-auto space-y-14 items-center" }
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = { class: "flex m-auto space-x-2.5" }
const _hoisted_17 = { class: "my-auto pt-0.5" }
const _hoisted_18 = {
  key: 0,
  class: "my-auto pt-0.5"
}
const _hoisted_19 = {
  key: 1,
  class: "my-auto"
}

import {
  alertController,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  onIonViewWillEnter,
  useIonRouter,
} from '@ionic/vue';
import {computed, onUnmounted, ref} from 'vue';
import ApiService from "@/services/api/apiService";
import VerifyIdCard from "@/components/VerifyIdCard.vue";
import VerifyIdImage from "@/components/VerifyIdImage.vue";
import {AccountType} from "@/definitions/AccountType";
import {Observable, ObservableEvent} from "@/services/observable/Observable";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileSettingsVerifyPage',
  setup(__props) {

const loading = ref(true)
const ionRouter = useIonRouter()
const busy = ref(false)
const status = ref()
const user = ref()

const observer = ref()

onIonViewWillEnter(async () => {
  await getStatus()
  user.value = await ApiService.User().authUser()
  loading.value = false

  observer.value = Observable.subscribe(async (response: any) => {
    if (response.event === ObservableEvent.VerificationStatusChanged) {
      await getStatus()
    }
  })

})

onUnmounted(() => {
  observer.value?.unsubscribe()
})

const getStatus = async () => {
  status.value = await ApiService.User().getVerificationStatus()
}

const goBack = async () => {
  await ionRouter.back()
}

const submitId = async () => {
  if (!canSubmitForVerification.value) return
  busy.value = true
  await ApiService.User().submitIdForVerification()
  await getStatus()
  busy.value = false
}

const cancelVerification = async () => {

  const alert = await alertController.create({
    header: 'Cancel verification',
    message: 'Are you sure you want to cancel your verification request? Once cancelled you will be able to change your id photos and resubmit.',
    buttons: [
      {text: 'Cancel', role: "cancel"},
      {
        text: 'Yes', role: "destructive", handler: async () => {
          busy.value = true
          await alert.dismiss()
          await ApiService.User().cancelIdVerification()
          await getStatus()
          busy.value = false
        }
      }
    ]
  })

  await alert.present()

}

const hasIdCardPhoto = computed(() => {
  if (!status.value) return false
  return status.value.id_card_photo
})
const hasIdPhoto = computed(() => {
  if (!status.value) return false
  return status.value.id_photo
})

const canVerifyImage = computed(() => {
  if (!status.value) return false
  return status.value.id_card_photo
})

const canSubmitForVerification = computed(() => {
  if (!status.value) return false
  return status.value.id_card_photo && status.value.id_photo
})

const awaitingVerification = computed(() => {
  if (!status.value) return false
  return status.value.submitted_at
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), {
                slot: "start",
                class: "mr-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: goBack,
                    class: "bg-brand-dark-gray rounded-md"
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("svg", {
                        class: "",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M6 11.9961H18",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }),
                        _createElementVNode("path", {
                          d: "M12 18L6 12L12 6",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), { class: "text-white font-medium text-2xl" }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Verify your Identity", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { class: "flex h-full" }, {
        default: _withCtx(() => [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("svg", {
                  class: "animate-spin h-10 w-10 text-white m-auto",
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("circle", {
                    class: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    "stroke-width": "4"
                  }),
                  _createElementVNode("path", {
                    class: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  })
                ], -1)
              ]))]))
            : _createCommentVNode("", true),
          (!loading.value && !awaitingVerification.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (user.value.account_type === _unref(AccountType).Individual)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[3] || (_cache[3] = [
                        _createElementVNode("div", { class: "text-white text-xl" }, "All pineapple users must verify their identity, we do this to keep our community safe and to combat against fake accounts. ", -1),
                        _createElementVNode("div", { class: "text-white text-xl" }, "We will accept any form of photo I.D that has a clear image of your face and your DOB on it. ", -1),
                        _createElementVNode("div", { class: "text-white text-xl" }, "You are welcome to cover any other personal data.", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (user.value.account_type === _unref(AccountType).Joint)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("div", { class: "text-white text-xl" }, "All pineapple users must verify their identity, we do this to keep our community safe and to combat against fake accounts, a single person image will not be approved for verification on a joint account. ", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (user.value.account_type === _unref(AccountType).Joint)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("div", { class: "text-brand-light-gray text-sm" }, [
                          _createElementVNode("div", { class: "text-base text-white" }, [
                            _createTextVNode("You are verifying as a "),
                            _createElementVNode("span", { class: "underline" }, "Joint"),
                            _createTextVNode(" account. ")
                          ]),
                          _createTextVNode(" We require that all individuals who will share the account are included in the verification image, along with their photo I.D. We will accept any form of photo I.D that has a clear image of your face and your DOB on it. ")
                        ], -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(VerifyIdCard, { user: user.value }, null, 8, ["user"]),
                    _createVNode(VerifyIdImage, { user: user.value }, null, 8, ["user"])
                  ]),
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "px-10 text-center text-sm text-brand-light-gray" }, "You may cover sensitive ID Card information, we only require visibility of name and DOB. ", -1))
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    onClick: submitId,
                    class: _normalizeClass([{
              'bg-opacity-40' : !canSubmitForVerification.value
            }, "flex bg-brand-lime rounded-full w-full h-14 font-medium text-xl text-brand-black transition-all"])
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      (!busy.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Submit "))
                        : _createCommentVNode("", true),
                      (busy.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[7] || (_cache[7] = [
                            _createElementVNode("svg", {
                              class: "animate-spin h-5 w-5 text-brand-black",
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "none",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("circle", {
                                class: "opacity-25",
                                cx: "12",
                                cy: "12",
                                r: "10",
                                stroke: "currentColor",
                                "stroke-width": "4"
                              }),
                              _createElementVNode("path", {
                                class: "opacity-75",
                                fill: "currentColor",
                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              })
                            ], -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ])
                  ], 2),
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-white text-sm px-8 text-center mt-4" }, [
                    _createTextVNode("Your Photo I.D Card and Verification Photo "),
                    _createElementVNode("span", { class: "font-bold underline" }, "will be removed from our servers"),
                    _createTextVNode(" once your identity has been verified.")
                  ], -1))
                ])
              ]))
            : _createCommentVNode("", true),
          (!loading.value && awaitingVerification.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "flex flex-col space-y-4 items-center" }, [
                    _createElementVNode("svg", {
                      width: "110",
                      height: "110",
                      viewBox: "0 0 110 110",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("rect", {
                        x: "2",
                        y: "2",
                        width: "106",
                        height: "106",
                        rx: "53",
                        fill: "#EBFF00"
                      }),
                      _createElementVNode("path", {
                        d: "M54.9996 43.29C53.9747 43.29 53.1496 44.1151 53.1496 45.14V47.73H56.8496V45.14C56.8496 44.1151 56.0245 43.29 54.9996 43.29ZM40.5696 48.47C39.3397 48.47 38.3496 49.4602 38.3496 50.69V65.49C38.3496 66.7199 39.3397 67.71 40.5696 67.71H69.4296C70.6595 67.71 71.6496 66.7199 71.6496 65.49V50.69C71.6496 49.4602 70.6595 48.47 69.4296 48.47H40.5696ZM47.9696 53.28C49.1957 53.28 50.1896 54.274 50.1896 55.5C50.1896 56.7261 49.1957 57.72 47.9696 57.72C46.7435 57.72 45.7496 56.7261 45.7496 55.5C45.7496 54.274 46.7435 53.28 47.9696 53.28ZM56.4796 53.28H67.9496C68.3583 53.28 68.6896 53.6113 68.6896 54.02C68.6896 54.4287 68.3583 54.76 67.9496 54.76H56.4796C56.0709 54.76 55.7396 54.4287 55.7396 54.02C55.7396 53.6113 56.0709 53.28 56.4796 53.28ZM56.4796 57.35H67.9496C68.3583 57.35 68.6896 57.6813 68.6896 58.09C68.6896 58.4987 68.3583 58.83 67.9496 58.83H56.4796C56.0709 58.83 55.7396 58.4987 55.7396 58.09C55.7396 57.6813 56.0709 57.35 56.4796 57.35ZM47.9696 59.2C50.6343 59.2 52.7796 60.617 52.7796 62.2872V62.9H43.1596V62.2872C43.1596 60.617 45.3049 59.2 47.9696 59.2ZM56.4796 61.42H67.9496C68.3583 61.42 68.6896 61.7513 68.6896 62.16C68.6896 62.5687 68.3583 62.9 67.9496 62.9H56.4796C56.0709 62.9 55.7396 62.5687 55.7396 62.16C55.7396 61.7513 56.0709 61.42 56.4796 61.42Z",
                        fill: "#1A1B22"
                      }),
                      _createElementVNode("rect", {
                        x: "2",
                        y: "2",
                        width: "106",
                        height: "106",
                        rx: "53",
                        stroke: "#EBFF00",
                        "stroke-width": "4"
                      })
                    ]),
                    _createElementVNode("div", { class: "flex flex-col w-full items-center space-y-2" }, [
                      _createElementVNode("div", { class: "flex m-auto text-white text-2xl font-medium text-center" }, [
                        _createTextVNode("Thank you for submitting your ID."),
                        _createElementVNode("br"),
                        _createTextVNode(" We’re reviewing it now. ")
                      ]),
                      _createElementVNode("div", { class: "m-auto text-brand-light-gray text-lg text-center" }, "This may take a few days to verify. ")
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("button", {
                      onClick: cancelVerification,
                      class: "flex w-full bg-brand-dark-gray rounded-full px-8 h-14 font-medium text-xl text-white transition-all"
                    }, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          (!busy.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Cancel verification "))
                            : _createCommentVNode("", true),
                          (busy.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[9] || (_cache[9] = [
                                _createElementVNode("svg", {
                                  class: "animate-spin h-5 w-5 text-white",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  fill: "none",
                                  viewBox: "0 0 24 24"
                                }, [
                                  _createElementVNode("circle", {
                                    class: "opacity-25",
                                    cx: "12",
                                    cy: "12",
                                    r: "10",
                                    stroke: "currentColor",
                                    "stroke-width": "4"
                                  }),
                                  _createElementVNode("path", {
                                    class: "opacity-75",
                                    fill: "currentColor",
                                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                  })
                                ], -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})